import { render } from "./SynthOnline.vue?vue&type=template&id=27e61214"
import script from "./SynthOnline.vue?vue&type=script&lang=js"
export * from "./SynthOnline.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Matvey\\Documents\\LMZ\\synth-online\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QKnob from 'quasar/src/components/knob/QKnob.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QBadge,QSlider,QToggle,QKnob});
